import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d5ff61e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "job_detail_contents_wrapper" }
const _hoisted_3 = { class: "job_detail_layout_header" }
const _hoisted_4 = { class: "job_detail_employment_status" }
const _hoisted_5 = { class: "job_detail_employment_status_label" }
const _hoisted_6 = { class: "job_detail_badge" }
const _hoisted_7 = {
  key: 0,
  class: "job_detail_badge_label is-document-screening"
}
const _hoisted_8 = {
  key: 1,
  class: "job_detail_badge_label is-interview"
}
const _hoisted_9 = {
  key: 2,
  class: "job_detail_badge_label is-final-interview"
}
const _hoisted_10 = {
  key: 3,
  class: "job_detail_badge_label is-unofficial-offer"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "job_detail_company_name" }
const _hoisted_13 = { class: "job_detail_annual_income" }
const _hoisted_14 = { class: "job_detail_company_info" }
const _hoisted_15 = {
  key: 0,
  class: "job_detail_company_info_location"
}
const _hoisted_16 = {
  key: 1,
  class: "job_detail_company_info_web"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 2,
  class: "job_detail_company_workUrl"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "job_detail_recommended_points" }
const _hoisted_21 = {
  key: 0,
  class: "job_detail_recommended_points_item"
}
const _hoisted_22 = {
  key: 1,
  class: "job_detail_recommended_points_item"
}
const _hoisted_23 = {
  key: 2,
  class: "job_detail_recommended_points_item"
}
const _hoisted_24 = {
  key: 3,
  class: "job_detail_recommended_points_item"
}
const _hoisted_25 = {
  key: 4,
  class: "job_detail_recommended_points_item"
}
const _hoisted_26 = {
  key: 5,
  class: "job_detail_recommended_points_item"
}
const _hoisted_27 = {
  key: 6,
  class: "job_detail_recommended_points_item"
}
const _hoisted_28 = {
  key: 7,
  class: "job_detail_recommended_points_item"
}
const _hoisted_29 = {
  key: 8,
  class: "job_detail_recommended_points_item"
}
const _hoisted_30 = {
  key: 9,
  class: "job_detail_recommended_points_item"
}
const _hoisted_31 = {
  key: 10,
  class: "job_detail_recommended_points_item"
}
const _hoisted_32 = {
  key: 11,
  class: "job_detail_recommended_points_item"
}
const _hoisted_33 = {
  key: 12,
  class: "job_detail_recommended_points_item"
}
const _hoisted_34 = {
  key: 13,
  class: "job_detail_recommended_points_item"
}
const _hoisted_35 = {
  key: 14,
  class: "job_detail_recommended_points_item"
}
const _hoisted_36 = {
  key: 15,
  class: "job_detail_recommended_points_item"
}
const _hoisted_37 = {
  key: 16,
  class: "job_detail_recommended_points_item"
}
const _hoisted_38 = {
  key: 17,
  class: "job_detail_recommended_points_item"
}
const _hoisted_39 = {
  key: 18,
  class: "job_detail_recommended_points_item"
}
const _hoisted_40 = {
  key: 19,
  class: "job_detail_recommended_points_item"
}
const _hoisted_41 = {
  key: 20,
  class: "job_detail_recommended_points_item"
}
const _hoisted_42 = {
  key: 21,
  class: "job_detail_recommended_points_item"
}
const _hoisted_43 = {
  key: 22,
  class: "job_detail_recommended_points_item"
}
const _hoisted_44 = {
  key: 23,
  class: "job_detail_recommended_points_item"
}
const _hoisted_45 = {
  key: 24,
  class: "job_detail_recommended_points_item"
}
const _hoisted_46 = {
  key: 25,
  class: "job_detail_recommended_points_item"
}
const _hoisted_47 = {
  key: 26,
  class: "job_detail_recommended_points_item"
}
const _hoisted_48 = {
  key: 27,
  class: "job_detail_recommended_points_item"
}
const _hoisted_49 = {
  key: 28,
  class: "job_detail_recommended_points_item"
}
const _hoisted_50 = {
  key: 29,
  class: "job_detail_recommended_points_item"
}
const _hoisted_51 = {
  key: 30,
  class: "job_detail_recommended_points_item"
}
const _hoisted_52 = {
  key: 31,
  class: "job_detail_recommended_points_item"
}
const _hoisted_53 = {
  key: 32,
  class: "job_detail_recommended_points_item"
}
const _hoisted_54 = {
  key: 33,
  class: "job_detail_recommended_points_item"
}
const _hoisted_55 = {
  key: 34,
  class: "job_detail_recommended_points_item"
}
const _hoisted_56 = {
  key: 35,
  class: "job_detail_recommended_points_item"
}
const _hoisted_57 = { class: "job_detail_layout_contents" }
const _hoisted_58 = { class: "job_detail_catch_copy" }
const _hoisted_59 = { class: "job_detail_description" }
const _hoisted_60 = {
  key: 0,
  class: "job_detail_description"
}
const _hoisted_61 = {
  key: 1,
  class: "job_detail_description"
}
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<div class=\"job_detail_jump\" data-v-3d5ff61e><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_description\" data-v-3d5ff61e>募集要項</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_location\" data-v-3d5ff61e>勤務地</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_conditions\" data-v-3d5ff61e>勤務条件・待遇</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_treatment\" data-v-3d5ff61e>制度・福利厚生</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_selection\" data-v-3d5ff61e>選考フロー</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_company\" data-v-3d5ff61e>会社概要</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_recommend\" data-v-3d5ff61e>おすすめポイント</a></div></div>", 1)
const _hoisted_63 = { class: "job_detail_list_title" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "job_detail_list_title_label" }, "募集要項", -1))
const _hoisted_65 = { class: "job_detail_list_item_title" }
const _hoisted_66 = { class: "job_detail_list_item_value" }
const _hoisted_67 = { class: "job_detail_list_item_value_inner" }
const _hoisted_68 = { class: "job_detail_list_title" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "job_detail_list_title_label" }, "勤務地", -1))
const _hoisted_70 = { class: "job_detail_list_item_title" }
const _hoisted_71 = { class: "job_detail_list_item_value" }
const _hoisted_72 = { class: "job_detail_list_item_value_inner" }
const _hoisted_73 = { class: "job_detail_list_title" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "job_detail_list_title_label" }, "勤務条件・待遇", -1))
const _hoisted_75 = { class: "job_detail_list_item_title" }
const _hoisted_76 = { class: "job_detail_list_item_value" }
const _hoisted_77 = { class: "job_detail_list_item_value_inner" }
const _hoisted_78 = { class: "job_detail_list_title" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "job_detail_list_title_label" }, "制度・福利厚生", -1))
const _hoisted_80 = { class: "job_detail_list_item_title" }
const _hoisted_81 = { class: "job_detail_list_item_value" }
const _hoisted_82 = { class: "job_detail_list_item_value_inner" }
const _hoisted_83 = { class: "job_detail_list_title" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "job_detail_list_title_label" }, "選考フロー", -1))
const _hoisted_85 = { class: "job_detail_list_item_title" }
const _hoisted_86 = { class: "job_detail_list_item_value" }
const _hoisted_87 = { class: "job_detail_list_item_value_inner" }
const _hoisted_88 = { class: "job_detail_list_title" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "job_detail_list_title_label" }, "会社概要", -1))
const _hoisted_90 = { class: "job_detail_list_item_title" }
const _hoisted_91 = { class: "job_detail_list_item_value" }
const _hoisted_92 = { class: "job_detail_list_item_value_inner" }
const _hoisted_93 = { class: "job_detail_list_title" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "job_detail_list_title_label" }, "おすすめポイント", -1))
const _hoisted_95 = { class: "job_detail_list_item" }
const _hoisted_96 = { class: "job_detail_list_item_recommend" }
const _hoisted_97 = { class: "job_detail_list_item_recommend_inner" }
const _hoisted_98 = {
  key: 0,
  class: "job_detail_list_item_recommend_staff"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "job_detail_list_item_recommend_staff_title" }, "マスメディアン 担当", -1))
const _hoisted_100 = { class: "job_detail_list_item_recommend_staff_name" }
const _hoisted_101 = { class: "job_detail_list_item_recommend_staff_mail" }
const _hoisted_102 = ["href"]
const _hoisted_103 = /*#__PURE__*/_createStaticVNode("<div class=\"job_detail_jump is-bottom\" data-v-3d5ff61e><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_description\" data-v-3d5ff61e>募集要項</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_location\" data-v-3d5ff61e>勤務地</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_conditions\" data-v-3d5ff61e>勤務条件・待遇</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_treatment\" data-v-3d5ff61e>制度・福利厚生</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_selection\" data-v-3d5ff61e>選考フロー</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_company\" data-v-3d5ff61e>会社概要</a></div><div class=\"job_detail_jump_item\" data-v-3d5ff61e><a class=\"job_detail_jump_item_link\" href=\"#jump_recommend\" data-v-3d5ff61e>おすすめポイント</a></div></div>", 1)
const _hoisted_104 = { class: "job_detail_notes" }
const _hoisted_105 = { class: "job_detail_notes_text" }
const _hoisted_106 = { class: "job_detail_notes_text_inner" }
const _hoisted_107 = {
  key: 0,
  class: "job_detail_button"
}
const _hoisted_108 = { class: "job_detail_button_inner" }
const _hoisted_109 = { class: "job_detail_button_apply" }
const _hoisted_110 = {
  key: 0,
  class: "job_detail_button_decline"
}
const _hoisted_111 = {
  key: 1,
  class: "job_detail_button_pending"
}

import BaseButton from '@/components/BaseButton.vue';
import BaseThreeButtonModal from '@/components/BaseThreeButtonModal.vue';
import Loading from '@/components/Loading.vue';
import BaseJobBadge from '@/components/BaseJobBadge.vue';
import { computed, onBeforeMount, onUnmounted, ref } from 'vue';
import { OfferDetail } from '@/types';
import { useStore } from 'vuex';
import axios from 'axios';
import { useRouter } from 'vue-router';

type GlobalError = {
  code: string;
  args: string[];
};
// 求人応募

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailView',
  props: {
  orderId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const orderId = Number(props.orderId);

const isLoading = ref(true);
const isClosed = ref({
  description: false,
  condition: false,
  location: false,
  treatment: false,
  selection: false,
  company: false,
  recommend: false,
});
const openedModal = ref({
  apply: false,
  decline: false,
});

const store = useStore();
const router = useRouter();

const offerDetail = computed(() => {
  return store.getters['offerDetail/offerDetail'] as OfferDetail;
});

onBeforeMount(async () => {
  isLoading.value = true;
  try {
    await store.dispatch('offerDetail/receive', { orderId });
    if (!store.getters['offerDetail/offerDetail'].dispOrderInfoFlg) {
      router.push({ name: '404' });
    }
    document.title = `求人詳細（${orderId}）｜マイページ｜マスメディアン`;
  } finally {
    isLoading.value = false;
  }
});

onUnmounted(() => {
  store.commit('offerDetail/reset');
});

const apiErrorMessages = ref<string[]>([]);
const applySubmit = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('offerDetail/apply', { orderId });
    store.dispatch('toasts/appendTimeToast', { label: '応募を完了しました' });
  } catch (error) {
    console.error(error);
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      error.response.data.errorDetail.globalError.map((e: GlobalError) => {
        return e.args.map((arg) => {
          apiErrorMessages.value.push(arg);
        });
      });
    }
    apiErrorMessages.value.forEach((message) => {
      store.dispatch('toasts/appendTimeToast', { label: message, duration: null });
    });
  } finally {
    isLoading.value = false;
    openedModal.value.apply = false;
  }
};

// 辞退
const declineSubmit = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('offerDetail/decline', { orderId });
    store.dispatch('toasts/appendTimeToast', { label: '求人を辞退しました' });
  } catch (error) {
    console.error(error);
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      error.response.data.errorDetail.globalError.map((e: GlobalError) => {
        return e.args.map((arg) => {
          apiErrorMessages.value.push(arg);
        });
      });
    }
    apiErrorMessages.value.forEach((message) => {
      store.dispatch('toasts/appendTimeToast', { label: message, duration: null });
    });
  } finally {
    isLoading.value = false;
    openedModal.value.decline = false;
  }
};

// 検討する
const toggleConsider = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('offerDetail/toggleConsider', { orderId });
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["is-nav", { 'is-sticky': _unref(offerDetail).orderStatusId !== 2 }])
  }, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(offerDetail).empTypeName) + " " + _toDisplayString(_unref(offerDetail).ocupctgName), 1),
                _createElementVNode("div", _hoisted_6, [
                  (_unref(offerDetail).applyStatus?.match(/書類選考/))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(offerDetail).applyStatus), 1))
                    : _createCommentVNode("", true),
                  (_unref(offerDetail).applyStatus?.match(/.+次面接・選考/))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(offerDetail).applyStatus), 1))
                    : _createCommentVNode("", true),
                  (_unref(offerDetail).applyStatus?.match(/最終面接・選考/))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(offerDetail).applyStatus), 1))
                    : _createCommentVNode("", true),
                  (_unref(offerDetail).applyStatus?.match(/内定/))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(offerDetail).applyStatus), 1))
                    : _createCommentVNode("", true)
                ]),
                (_unref(offerDetail).applyStatus === '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createVNode(BaseJobBadge, {
                        badge: _unref(offerDetail).badge,
                        aiMatchBadge: _unref(offerDetail).aiMatchBadge,
                        unread: false
                      }, null, 8, ["badge", "aiMatchBadge"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(offerDetail).companyName), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(offerDetail).salary), 1),
              _createElementVNode("div", _hoisted_14, [
                (_unref(offerDetail).location)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(offerDetail).location), 1))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).url)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("a", {
                        class: "text_link",
                        href: _unref(offerDetail).url,
                        target: "_blank"
                      }, _toDisplayString(_unref(offerDetail).url), 9, _hoisted_17)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).workUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("a", {
                        class: "text_link",
                        href: _unref(offerDetail).workUrl,
                        target: "_blank"
                      }, _toDisplayString(_unref(offerDetail).workUrl + _unref(offerDetail).filesize), 9, _hoisted_19)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_unref(offerDetail).recommendedPoint1_4DayworkFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "週1～4日以内の勤務"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointWeekendOffFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "土日祝休み"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointSrtWkhourFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, "時短勤務"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPoint1_5HourworkFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, "勤務時間1日5時間以内"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointNoOvertimeFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, "残業なし"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointOvertimeFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "残業月20時間以内"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointWorkFrom_10Flg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "始業10時以降"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointWorkTo_18Flg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, "終業18時以前"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointFlextimeFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "フレックスタイム制"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointSalary_130Flg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, "年収130万円以内"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointHomeBasedFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "在宅・リモートワーク"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointSideWorkFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, "副業・兼業OK"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointNoRelocationFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, "転勤なし"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointTransportPaidFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, "交通費全額支給"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointChildcareSupportFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, "育児支援制度充実"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointComHouseSupportFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, "社宅・家賃補助制度"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointTrainingFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, "研修制度充実"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointStationFrom_5Flg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, "駅から徒歩5分以内"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointClothingFreeFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, "服装自由"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointHairstyleFreeFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, "髪型自由"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointListedFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "上場企業"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointForeignComFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, "外資系企業"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPoint2year_10percentFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, " 2年連続売上10％以上UP "))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointFounded_5yearFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, "設立5年以内"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointMidcareerIn_50Flg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, "中途入社5割以上"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointFemale_50percentFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, "女性社員が5割以上"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointFemaleActiveFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, "女性が活躍中"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointInexperienceFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "未経験者歓迎"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointSemiGradFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, "第二新卒歓迎"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointNoEducationFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, "学歴不問"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointUseEnglishFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, "語学を活かす-英語"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointUseOtherEnglishFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, " 語学を活かす-英語以外 "))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointManagerRecruitFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_53, " 部長・幹部・管理職募集 "))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointUiTurnFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, "U・Iターン歓迎"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointShufumamaFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, "しゅふクリ・ママクリ"))
                  : _createCommentVNode("", true),
                (_unref(offerDetail).recommendedPointExecutiveFlg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_56, "エグゼクティブ"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(offerDetail).catchCopy), 1),
              _createElementVNode("pre", _hoisted_59, _toDisplayString(_unref(offerDetail).comments), 1),
              (_unref(offerDetail).aiRecommendation)
                ? (_openBlock(), _createElementBlock("pre", _hoisted_60, "＜AIが" + _toDisplayString(_unref(offerDetail).careerLastName) + "様におすすめする理由＞", 1))
                : _createCommentVNode("", true),
              (_unref(offerDetail).aiRecommendation)
                ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_unref(offerDetail).aiRecommendation), 1))
                : _createCommentVNode("", true),
              _hoisted_62,
              _createElementVNode("div", {
                class: _normalizeClass(["job_detail_list", { 'is-close': isClosed.value.description }]),
                id: "jump_description"
              }, [
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("span", {
                    class: "job_detail_list_title_icon",
                    onClick: _cache[0] || (_cache[0] = () => (isClosed.value.description = !isClosed.value.description))
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(offerDetail).applicationRequirementsList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "job_detail_list_item",
                    key: item.subtile
                  }, [
                    _createElementVNode("div", _hoisted_65, _toDisplayString(item.subtile), 1),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("pre", _hoisted_67, _toDisplayString(item.detailedInfomation), 1)
                    ])
                  ]))
                }), 128))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["job_detail_list", { 'is-close': isClosed.value.location }]),
                id: "jump_location"
              }, [
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("span", {
                    class: "job_detail_list_title_icon",
                    onClick: _cache[1] || (_cache[1] = () => (isClosed.value.location = !isClosed.value.location))
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(offerDetail).workLocationList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "job_detail_list_item",
                    key: item.subtile
                  }, [
                    _createElementVNode("div", _hoisted_70, _toDisplayString(item.subtile), 1),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("pre", _hoisted_72, _toDisplayString(item.detailedInfomation), 1)
                    ])
                  ]))
                }), 128))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["job_detail_list", { 'is-close': isClosed.value.condition }]),
                id: "jump_conditions"
              }, [
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _createElementVNode("span", {
                    class: "job_detail_list_title_icon",
                    onClick: _cache[2] || (_cache[2] = () => (isClosed.value.condition = !isClosed.value.condition))
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(offerDetail).workingConditionAndTreatmentList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "job_detail_list_item",
                    key: item.subtile
                  }, [
                    _createElementVNode("div", _hoisted_75, _toDisplayString(item.subtile), 1),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("pre", _hoisted_77, _toDisplayString(item.detailedInfomation), 1)
                    ])
                  ]))
                }), 128))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["job_detail_list", { 'is-close': isClosed.value.treatment }]),
                id: "jump_treatment"
              }, [
                _createElementVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _createElementVNode("span", {
                    class: "job_detail_list_title_icon",
                    onClick: _cache[3] || (_cache[3] = () => (isClosed.value.treatment = !isClosed.value.treatment))
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(offerDetail).systemAndBenefitsList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "job_detail_list_item",
                    key: item.subtile
                  }, [
                    _createElementVNode("div", _hoisted_80, _toDisplayString(item.subtile), 1),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("pre", _hoisted_82, _toDisplayString(item.detailedInfomation), 1)
                    ])
                  ]))
                }), 128))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["job_detail_list", { 'is-close': isClosed.value.selection }]),
                id: "jump_selection"
              }, [
                _createElementVNode("div", _hoisted_83, [
                  _hoisted_84,
                  _createElementVNode("span", {
                    class: "job_detail_list_title_icon",
                    onClick: _cache[4] || (_cache[4] = () => (isClosed.value.selection = !isClosed.value.selection))
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(offerDetail).selectionFlowList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "job_detail_list_item",
                    key: item.subtile
                  }, [
                    _createElementVNode("div", _hoisted_85, _toDisplayString(item.subtile), 1),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("pre", _hoisted_87, _toDisplayString(item.detailedInfomation), 1)
                    ])
                  ]))
                }), 128))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["job_detail_list", { 'is-close': isClosed.value.company }]),
                id: "jump_company"
              }, [
                _createElementVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createElementVNode("span", {
                    class: "job_detail_list_title_icon",
                    onClick: _cache[5] || (_cache[5] = () => (isClosed.value.company = !isClosed.value.company))
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(offerDetail).companyInfoList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "job_detail_list_item",
                    key: item.subtile
                  }, [
                    _createElementVNode("div", _hoisted_90, _toDisplayString(item.subtile), 1),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("pre", _hoisted_92, _toDisplayString(item.detailedInfomation), 1)
                    ])
                  ]))
                }), 128))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["job_detail_list", { 'is-close': isClosed.value.recommend }]),
                id: "jump_recommend"
              }, [
                _createElementVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _createElementVNode("span", {
                    class: "job_detail_list_title_icon",
                    onClick: _cache[6] || (_cache[6] = () => (isClosed.value.recommend = !isClosed.value.recommend))
                  })
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("pre", _hoisted_97, _toDisplayString(_unref(offerDetail).recommendedPoint), 1),
                    (_unref(offerDetail).orderChargeName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                          _hoisted_99,
                          _createElementVNode("div", _hoisted_100, _toDisplayString(_unref(offerDetail).orderChargeName), 1),
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("a", {
                              class: "text_link",
                              href: 'mailto:' + _unref(offerDetail).orderChargeMailAddress
                            }, _toDisplayString(_unref(offerDetail).orderChargeMailAddress), 9, _hoisted_102)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2),
              _hoisted_103,
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("pre", _hoisted_106, _toDisplayString(_unref(offerDetail).notes), 1)
                ])
              ])
            ])
          ]),
          (_unref(offerDetail).orderStatusId !== 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _createVNode(BaseButton, {
                      theme: "primary",
                      onClick: _cache[7] || (_cache[7] = () => (openedModal.value.apply = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("応募する")
                      ]),
                      _: 1
                    })
                  ]),
                  (_unref(offerDetail).orderStatusId === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                        _createVNode(BaseButton, {
                          theme: "secondary",
                          onClick: _cache[8] || (_cache[8] = () => (openedModal.value.decline = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("辞退する")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(offerDetail).orderStatusId === 0 || _unref(offerDetail).orderStatusId === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                        (!_unref(offerDetail).considerFlg)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "job_detail_button_pending_label",
                              onClick: toggleConsider
                            }, "検討する"))
                          : _createCommentVNode("", true),
                        (_unref(offerDetail).considerFlg)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "job_detail_button_pending_label is-pending",
                              onClick: toggleConsider
                            }, "検討中"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (openedModal.value.apply)
            ? (_openBlock(), _createBlock(BaseThreeButtonModal, {
                key: 1,
                "right-btn-text": "応募する",
                "left-btn-text": "キャンセル",
                "bottom-btn-disabled": true,
                onRightBtnClick: applySubmit,
                onLeftBtnClick: _cache[9] || (_cache[9] = () => (openedModal.value.apply = false))
              }, _createSlots({
                large: _withCtx(() => [
                  _createTextVNode("応募します。よろしいですか？")
                ]),
                _: 2
              }, [
                (_unref(offerDetail).considerFlg)
                  ? {
                      name: "default",
                      fn: _withCtx(() => [
                        _createTextVNode("応募すると検討中リストからは削除されます。")
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024))
            : _createCommentVNode("", true),
          (openedModal.value.decline)
            ? (_openBlock(), _createBlock(BaseThreeButtonModal, {
                key: 2,
                "right-btn-text": "辞退する",
                "left-btn-text": "キャンセル",
                "bottom-btn-disabled": true,
                onRightBtnClick: declineSubmit,
                onLeftBtnClick: _cache[10] || (_cache[10] = () => (openedModal.value.decline = false))
              }, _createSlots({
                large: _withCtx(() => [
                  _createTextVNode("辞退します。よろしいですか？")
                ]),
                _: 2
              }, [
                (_unref(offerDetail).considerFlg)
                  ? {
                      name: "default",
                      fn: _withCtx(() => [
                        _createTextVNode("辞退すると検討中リストからは削除されます。")
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})